// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0ea03b98","637":"aeda516b"}[chunkId] + ".chunk.js";
};